import { Injectable } from '@angular/core';
import { InitResetPasswordRequestDTO } from '@paymash/local-sdk/dto/request';
import { ResetPasswordPayload } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordMapper {

  public mapToDTO(entity: ResetPasswordPayload): InitResetPasswordRequestDTO {
    return {
      email: entity.email
    };
  }
}
